export const environment = {
  name: '%%{ENV}%%',
  production: true,
  apiUrl: '%%{API_URL}%%',
  language: '%%{LANGUAGE}%%',
};
